import React from 'react';
import { ArrowDownIcon, ArrowRightIcon, BotIcon, UserCheckIcon } from 'lucide-react';
import { AGENT_DUTIES, HUMAN_DUTIES } from '../../data/platform';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
function DutyColumn({
  title,
  icon,
  items,
  emphasis
}: {
  title: string;
  icon: React.ReactNode;
  items: readonly string[];
  emphasis?: boolean;
}) {
  return <div className={emphasis ? 'rounded-2xl border border-violet/50 bg-violet/10 p-6' : 'rounded-2xl border border-night-line bg-night-panel p-6'} data-id="element-803" data-mp="2l07e5r41v8qp">
      <div className="flex items-center gap-3" data-id="element-804" data-mp="2g3gz973zej6v">
        <span className={emphasis ? 'flex h-10 w-10 items-center justify-center rounded-xl bg-violet text-white' : 'flex h-10 w-10 items-center justify-center rounded-xl bg-night-raised text-night-muted'} data-id="element-805" data-mp="2u1x4suq3y3nf">
          {icon}
        </span>
        <p className="text-sm font-semibold uppercase tracking-[0.12em] text-night-text" data-id="element-806" data-mp="99lhmfuovybg">{title}</p>
      </div>
      <ul className="mt-5 flex flex-wrap gap-2" data-id="element-807" data-mp="4btmze2nty3k">
        {items.map(item => <li key={item} className={emphasis ? 'rounded-lg bg-violet px-3.5 py-2 text-sm font-semibold text-white' : 'rounded-lg border border-night-line bg-night-2 px-3.5 py-2 text-sm font-medium text-night-muted'} data-id="element-808" data-mp="1mej92vmouv7j">
            {item}
          </li>)}
      </ul>
    </div>;
}
export function HumanControl({
  placement = 'home'
}: {
  placement?: string;
}) {
  return <section aria-labelledby={`${placement}-human-heading`} className="dgpt-dark border-b border-night-line bg-night" data-id="element-809" data-mp="17pestjzgf122">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-20 sm:px-6 lg:px-8 lg:py-28" data-id="element-810" data-mp="1cohmk89zhkuq">
        <SectionHeading tone="dark" eyebrow="Human in control" headingId={`${placement}-human-heading`} title={<>
              AI Runs the Process. <em data-id="element-812" data-mp="oyn9bplr5u9y">Your Team Makes the Decision.</em>
            </>} description="DiligenceGPT automates repetitive diligence work while preserving human control over consequential decisions." data-id="element-811" data-mp="1hh16ro36fe8i" />
        <Reveal className="mt-12 grid gap-4 lg:grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] lg:items-center" data-id="element-813" data-mp="cww0tu922aqv">
          <DutyColumn title="Agents" icon={<BotIcon className="h-5 w-5" aria-hidden="true" data-id="element-815" data-mp="lppmc9f3i6d6" />} items={AGENT_DUTIES} data-id="element-814" data-mp="qo0rw7ycxupl" />
          <div className="flex flex-col items-center gap-1 py-1 text-night-faint" aria-hidden="true" data-id="element-816" data-mp="ls200adtlukf">
            <span className="text-[11px] font-semibold uppercase tracking-[0.12em]" data-id="element-817" data-mp="3u7c5lsgx5hwy">Hand off</span>
            <ArrowDownIcon className="h-5 w-5 lg:hidden" data-id="element-818" data-mp="3q6a414zj4trt" />
            <ArrowRightIcon className="hidden h-5 w-5 lg:block" data-id="element-819" data-mp="7z414e265kc4" />
          </div>
          <DutyColumn title="Humans" icon={<UserCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-821" data-mp="2xwoo1p2zwz4" />} items={HUMAN_DUTIES} emphasis data-id="element-820" data-mp="2y6hdx1igi8i" />
        </Reveal>
      </div>
    </section>;
}